<template>
  <div>
    <div class="container bg_gray" v-if="orderList.data.length > 0">
      <div class="order_item_common"
           v-for="(order_item, order_index) in orderList.data" :key="order_index">
        <div class="selection">
          <van-checkbox v-model="order_item.checked" shape="square"  checked-color="#52c41a" icon-size="15"
                       :disabled="orderItemCheckBoxDisabledNotify(order_item)"
                       @change="selectionChangeHandler"></van-checkbox>
        </div>
        <div class="content_all">
          <div class="head_wrap">
            <div class="no">订单号:{{ order_item.order_sn }}</div>
            <div class="date">{{ order_item.created_at_local }}</div>
          </div>
          <div class="content_wrap">
            <div class="items" v-for="(goods_item, goods_index) in order_item.order_goods" :key="goods_index">
              <div class="course_item_common" v-if="goods_item.goods_type == 'curriculum'">
                <div class="cover" @click="$emit('curDetailHandler', goods_item.goods_info.cur_uuid)">
                  <img :src="goods_item.cur_cover"/>
                  <span class="hot" v-if="goods_item.cur_label && goods_item.cur_label != 'null'">{{goods_item.cur_label}}</span>
                  <span class="tag" v-if="goods_item.cur_type">{{ goods_item.cur_type }}</span>
                </div>
                <div class="content">
                  <h4 class="text_ellipsis"
                      :title="goods_item.goods_info.name" @click="$emit('curDetailHandler', goods_item.goods_info.cur_uuid)">{{ goods_item.goods_info.name }}</h4>
                  <div class="info">
                    <div>课时：{{ goods_item.chapter_desc }}</div>
                    <div>价格：¥ {{ goods_item.goods_total }}&nbsp;&nbsp;优惠：¥ {{ parseFloat((goods_item.discount_amount + goods_item.reduce_discount).toFixed(2)) }}</div>
                  </div>
                  <div class="price">实付：¥ {{ goods_item.amount }}</div>
                </div>
              </div>
              <div v-if="goods_item.goods_type == 'vip'">
                <VipCard :vip_card="goods_item.goods_info"
                         :expired_at="goods_item.goods_info.expired_detail_text"
                         :price_visible="false" :btn_buy="false"
                         :btn_detail="false" :margin_bottom_0="true"></VipCard>

                <div>
                  <div style="margin-top: 5px;float: right;color:#999">
                    价格：¥ {{ goods_item.goods_total }}&nbsp;&nbsp;
                    优惠：¥ {{ parseFloat((goods_item.goods_total + goods_item.reduce_discount).toFixed(2)) }}&nbsp;&nbsp;
                    实付：¥ {{ goods_item.amount }}
                  </div>
                  <br>
                </div>

              </div>

            </div>

            <div class="btns">
              <div class="countdown" v-if="order_item.state_text === '待支付'"> 请在
                <span style="color:#F51C21;">
                          <Countdown :remainTime="order_item.cancel_seconds" :orderSn="order_item.order_sn"
                                     @countDowmEnd="countDownEnd(order_item)"></Countdown>
                        </span> 内完成支付
              </div>
              <div class="countdown" v-else-if="order_item.state_text === '已支付'">
                <span>已完成</span>
              </div>
              <div class="countdown" v-else-if="order_item.state_text === '已取消'">
                <span>已取消</span>
              </div>
              <div class="countdown" v-else-if="order_item.state_text === '待收款'">
                <span>待收款</span>
              </div>
              <div class="countdown" v-else-if="order_item.state_text === '已关闭'">
                <span>已关闭</span>
              </div>

              <div class="wrap" v-if="order_item.state_text === '待支付'">
                <van-button type="danger" size="small" @click="payOrderHandler(order_item.uuid)">去支付</van-button>
                <van-button type="default" size="small" @click="cancelOrderHandler(order_item.uuid)">取消订单</van-button>
              </div>

              <div class="wrap" v-if="order_item.state_text === '已取消' || order_item.state_text === '已关闭'">
                <van-button type="default" size="small" @click="deleteOrderHandler(order_item.uuid)">删除</van-button>
              </div>
              <div class="wrap" v-if="order_item.state_text === '待收款'">
                <van-button type="default" size="small" @click="payOrderHandler(order_item.uuid)">更换支付方式</van-button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <van-empty v-else description="暂无内容哦~"></van-empty>

    <!-- 操作底板 -->
    <div class="sheet_fixed_bottom_common">
      <div class="text-right">
        <van-button type="danger" :disabled="cmdPayDisabled" @click="orderCommandHandler('pay')">支付</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import Countdown from 'components/common/Countdown'
  import Pagination from 'components/common/Pagination'
  import VipCard from "components/mobile/settlement/VipCard"
  export default {
    components: {
      Countdown,
      Pagination,
      VipCard
    },
    props: {
      orderList: {
        type: Object,
        default: null
      },
      emptyDesc: {
        type: String,
        default: '暂无课程订单'
      },
      cmdPayDisabled: {
        type: Boolean,
        default: true
      },
      cmdDelDisabled: {
        type: Boolean,
        default: true
      },
    },
    data() {
        return {
            selectedRows: [],
        }
    },
    mounted() {
//         console.log('components-OrderRecordList->', this.orderList);
    },
    methods: {
      btnSelect(action) { console.log(action.uuid);
        if(action.text === '更改支付方式') {
          this.payOrderHandler(action.uuid)
        }
        if(action.text === '取消订单') {
          this.cancelOrderHandler(action.uuid)
        }
      },
      orderItemCheckBoxDisabledNotify(order_item){
        return ['待收款', '已支付', '已取消', '已关闭'].includes(order_item.state_text);
      },
      getPager(pager) { //获取分页变化后数据
        this.$emit('getPagerHandler', pager)
      },
      orderCommandHandler(command) {  //批量操作
        this.$emit('orderCommandHandler', command)
      },
      notifySelectedRows(){

        this.selectedRows = [];

        const that = this;
        this.orderList.data.forEach(item => {

          if (item.checked) {
            that.selectedRows.push(item);
          }

        });

      },
      selectionChangeHandler(val) {

        this.notifySelectedRows();
        this.notifyBatchCMDBtn();

        this.$emit('selectionChangeHandler', this.selectedRows)
      },

      notifyBatchCMDBtn(){
        // 统计选中订单的状态数量
        let unpay_count = 0;
        let canceled_count = 0;
        let uncashed_count = 0;
        let payed_count = 0;
        let closed_couont = 0;
        this.selectedRows.forEach(item => {

          switch (parseInt(item.state)) {
            case 1 : { //'待支付'
              unpay_count++;
            }
              break;
            case 2 : {//已取消
              canceled_count++;
            }
              break;
            case 3 : {//待收款
              uncashed_count++;
            }
              break;
            case 4 : {//已支付
              payed_count++;
            }
              break;
            case 5 : {//已关闭
              closed_couont++;
            }
              break;
          }

        });

        let multi_pay_disabled = false;
        let multi_delete_disabled = false;

        if (unpay_count > 0 &&
          canceled_count === 0 && uncashed_count === 0 && payed_count === 0 && closed_couont === 0) {
          multi_pay_disabled = false;
        } else {
          multi_pay_disabled = true;
        }
        if ((closed_couont + canceled_count) > 0 && uncashed_count === 0 && payed_count === 0 && unpay_count === 0) {
          multi_delete_disabled = false;
        } else {
          multi_delete_disabled = true;
        }

        this.$emit('notifyBatchBtn', multi_pay_disabled, 'pay');
        this.$emit('notifyBatchBtn', multi_delete_disabled, 'delete');
      },

      countDownEnd(order_item) {
        this.$emit('countDownEndHandler', order_item)
      },
      payOrderHandler(order_uuid){
          this.$emit('payOrderHandler', order_uuid)
      },
      cancelOrderHandler(order_uuid){
        this.$emit('cancelOrderHandler', order_uuid)
      },
      deleteOrderHandler(order_uuid){
        this.$emit('deleteOrderHandler',order_uuid)
      }
    },
  }
</script>

<style lang="scss">
  .popover {
    .van-popover__content {
      border-radius:2px;
      .van-popover__action {
        width:90px;
        height:36px;
        padding:0;
        .van-popover__action-text {
          font-size:12px;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .container {
    padding:10px 0 ;
  }
  .info_sm {
    font-size:12px;
    display:flex;
    margin-bottom:20px;
    span {
      flex: 1;
    }
  }
</style>
